import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword
} from "firebase/auth";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  runTransaction,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { db } from "../firebase"; // Importar la instancia de Firestore que has creado previamente

const registers = {};

const auth = getAuth();

registers.registerOrLoginWithDNI = (data) => {
  return new Promise(async (resolve, reject) => {
    const email = `${data.cc}@mamabrilla.com`;
    const password = `${data.cc}xxx`;

    try {
      // Comprobar si el usuario ya existe en Firestore
      const usersRef = collection(db, "usersClients");
      const q = query(usersRef, where("cc", "==", data.cc));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.size > 0) {
        // Iniciar sesión
        await signInWithEmailAndPassword(auth, email, password);
        resolve(true);
      } else {
        // Crear usuario en Auth
        const { user } = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );

        // Iniciar transacción para asignar un número único al usuario
        const configRef = doc(db, "config", "configurations");
        await runTransaction(db, async (transaction) => {
          const configDoc = await transaction.get(configRef);
          const drawNumber = configDoc.data().number + 1;
          const newUserRef = doc(usersRef, user.uid);
          transaction.update(configRef, { number: increment(1) });
          transaction.set(newUserRef, {
            ...data,
            emailAuth: email,
            timestamp: serverTimestamp(),
            number: drawNumber,
          });
        });

        // Devolver los datos del usuario recién creado
        resolve(true);
      }
    } catch (error) {
      console.error(error);
      reject(
        new Error(
          "Ha ocurrido un error al registrar o iniciar sesión con el DNI proporcionado."
        )
      );
    }
  });
};

export default registers;
